// extracted by mini-css-extract-plugin
module.exports = {"Submenu":"Submenu_Submenu__3_nL8","Active":"Submenu_Active__2H8n3"};